import { WebglSettingsConverter } from "../../webgl-settings-converter";
import { ObjectCreator } from "../../../../../../../web-graphics";
import { VisualizatorSettings } from "../../../settings/visualizator-settings";

export class SignalWebglSettingsConverter extends WebglSettingsConverter {
  constructor(commonSettings) {
    super();
    this.commonSettings = commonSettings;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    delete settingsCopy.id_signal;
    settingsCopy.id = settings.id_signal;
    let commonSignalSettings = settings._commonSettings;
    if (commonSignalSettings !== undefined) {
      for (const key of Object.getOwnPropertyNames(commonSignalSettings)) {
        if (settingsCopy[key] === undefined) {
          if (commonSignalSettings[key] instanceof VisualizatorSettings) {
            settingsCopy[key] = commonSignalSettings[key].copy();
          } else {
            settingsCopy[key] = ObjectCreator.deepCopy(commonSignalSettings[key]);
          }
        }
      }
    }
    return settingsCopy;
  }
}
